'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// import AnimateOnChange from 'react-animate-on-change';

var LineupUsername = function (_PureComponent) {
    _inherits(LineupUsername, _PureComponent);

    function LineupUsername(props) {
        _classCallCheck(this, LineupUsername);

        var _this = _possibleConstructorReturn(this, (LineupUsername.__proto__ || Object.getPrototypeOf(LineupUsername)).call(this, props));

        _this.state = {
            lineupChanged: false
        };
        return _this;
    }
    // todo
    // this is apparently broken because previousProps is the same as this.props by the time the lineupcard loads


    _createClass(LineupUsername, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(previousProps) {
            // console.log("WILL-RECEIVE", previousProps.userName, this.props.userName);
            if (previousProps.userName !== this.props.userName || previousProps.lineupTag !== this.props.lineupTag) {
                this.setState({ lineupChanged: true });
            } else {
                this.setState({ lineupChanged: false });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return this.props.userName ? this.props.userName : this.props.lineupTag;

            // <AnimateOnChange
            //   baseClassName="Animate"
            //   animationClassName={'Animate--fadein'}
            //   animate={this.state.lineupChanged}>
            //     <div style={{paddingTop:'9px'}}>
            //       {this.props.userName
            //         ? this.props.userName
            //         : this.props.lineupTag
            //       }
            //     </div>
            // </AnimateOnChange>
        }
    }]);

    return LineupUsername;
}(_react.PureComponent);

exports.default = LineupUsername;


//////////////////
// WEBPACK FOOTER
// ../component-library/build/lineups/LineupUsername.js
// module id = 847
// module chunks = 0